<mat-list class="list-container no-focus">
  <mat-list-item *ngFor="let contest of contests"
                 class="list-option no-focus"
                 [class.details]="mobileView || detailsAction"
                 (click)="showDetails(contest)">
    <div class="list-item-content full-width" [class.text-secondary-color]="isContestFinished(contest)" fxLayout="row">
      <div fxLayout="column" [fxFlex]="!showPayment ? '40%' : '30%'" class="list-item-column contest-name">
        <span class="top text-disabled-color mat-small" [class.mat-small]="mobileView"
              i18n="Contests List|Contests list item 'name' title@@contests-list-item-name-title">Name:</span>
        <span class="word-wrap" [class.mat-small]="mobileView">{{contest.name}}</span>
      </div>

      <div *ngIf="showEnrolEnd && !mobileView" fxLayout="column" fxFlex="20%"
           class="list-item-column contest-enrol-ends-at">
        <span class="top text-disabled-color mat-small"
              i18n="Contests List|Contests list item 'enrol ends at' title@@contests-list-item-enrol-ends-at-title">Enrol Ends At:</span>
        <span class="word-wrap"
              [class.mat-small]="mobileView">{{contest.enrolEndsAt | date:mobileView ? 'short' : 'medium'}}</span>
      </div>

      <div fxLayout="column" [fxFlex]="mobileView || (!showEnrolEnd && !showTeacher) ? '30%' : '20%'"
           class="list-item-column contest-starts-at">
        <span class="top text-disabled-color mat-small" [class.mat-small]="mobileView"
              i18n="Contests List|Contests list item 'starts at' title@@contests-list-item-starts-at-title">Starts At:</span>
        <span class="word-wrap"
              [class.mat-small]="mobileView">{{contest.startsAt | date:mobileView ? 'short' : 'medium'}}</span>
      </div>

      <div *ngIf="!mobileView" fxLayout="column" [fxFlex]="!showEnrolEnd && !showTeacher ? '30%' : '20%'"
           class="list-item-column contest-ends-at">
        <span class="top text-disabled-color mat-small" [class.mat-small]="mobileView"
              i18n="Contests List|Contests list item 'ends at' title@@contests-list-item-ends-at-title">Ends At:</span>
        <span class="word-wrap">{{contest.endsAt | date:mobileView ? 'short' : 'medium'}}</span>
      </div>

      <div *ngIf="!mobileView && showTeacher" fxLayout="column" fxFlex="20%" class="list-item-column contest-teacher">
        <span class="top text-disabled-color mat-small"
              [class.mat-small]="mobileView">{{ teacherLabel }}:</span>
        <span *ngIf="contest.teacher_id; else noTeacher">
          <span class="word-wrap">{{contest.teacher_first_name}} {{contest.teacher_last_name}}</span>

          <a *ngIf="!isContestFinished(contest) && !!userRegion && !!userSchool"
             class="text-disabled-color teacher-action" [class.mat-small]="mobileView"
             (click)="assignTeacher(contest)"
             i18n="General|Change term@@change-term">change</a>
        </span>
        <ng-template #noTeacher>
          <span [class.text-disabled-color]="isContestFinished(contest)"
                [class.color-orange]="!isContestFinished(contest)"
                [class.mat-small]="mobileView"
                i18n="General|Not selected title@@general-not-selected-title">not selected</span>
          <a *ngIf="!isContestFinished(contest) && !!userRegion && !!userSchool"
             class="teacher-action" [class.mat-small]="mobileView"
             (click)="assignTeacher(contest)"
             i18n="General|Select term@@select-term">select</a>
        </ng-template>
      </div>

      <div
        *ngIf="showPayment && ((!isContestInProgress(contest) && !isContestFinishedForStudent(contest)) || contest.paymentStatus != paymentStatuses.successful)"
        fxLayout="column"
        fxFlex="10%"
        class="list-item-column contest-payment">
        <span class="top text-disabled-color mat-small"
              i18n="Contests List|Contests list item 'payment' title@@contests-list-item-payment-title">Payment:</span>
        <span *ngIf="contest.paymentStatus" class="word-wrap" [class.mat-small]="mobileView"
              [class.color-green]="contest.paymentStatus == paymentStatuses.successful"
              [class.color-warn]="contest.paymentStatus == paymentStatuses.failed || contest.paymentStatus == paymentStatuses.rejected"
              [class.color-primary]="contest.paymentStatus == paymentStatuses.pending">
          <span *ngIf="!mobileView">{{localizeStatus(contest.paymentStatus)}}</span>
          <mat-icon *ngIf="mobileView"
                    [matTooltip]="localizeStatus(contest.paymentStatus)">{{mobileStatusIcon(contest.paymentStatus)}}</mat-icon>
        </span>
        <span *ngIf="!contest.paymentStatus">&#8211;</span>
        <a
          *ngIf="contestsOpenForEnrol && (contest.paymentStatus == paymentStatuses.failed || contest.paymentStatus == paymentStatuses.rejected) && retryAllowed(contest)"
          class="text-disabled-color word-wrap" [class.mat-small]="mobileView"
          (click)="retryClicked(contest)"
          i18n="Contests List|Contests list item payment retry link title@@contests-list-item-payment-retry-link-title">
          try again
        </a>
        <a *ngIf="contestsOpenForEnrol && contest.paymentStatus == paymentStatuses.scheduled && retryAllowed(contest)"
           class="text-disabled-color word-wrap" [class.mat-small]="mobileView"
           (click)="retryClicked(contest);"
           i18n="Contests List|Contests list item pay link title@@contests-list-item-pay-link-title">
          pay
        </a>
        <a *ngIf="contest.paymentStatus == paymentStatuses.pending"
           class="text-disabled-color word-wrap" [class.mat-small]="mobileView"
           (click)="verifyClicked(contest)"
           i18n="Contests List|Contests list item check status link title@@contests-list-item-check-status-link-title">
          verify
        </a>
      </div>

      <div *ngIf="isContestInProgress(contest) && contest.paymentStatus == paymentStatuses.successful"
           fxLayout="column"
           fxFlex="10%"
           class="list-item-column">
        <span class="top text-disabled-color mat-small">
          <ng-container
            i18n="General|Participate action label@@general-participate-action-label">Participate</ng-container>:</span>

        <app-button color="primary" icon="cast_for_education" class="center-vertical participate-btn"
                    matTooltip="Participate"
                    i18n-matTooltip="General|Participate action label@@general-participate-action-label"
                    (clicked)="goToExam(contest); $event.stopPropagation();"></app-button>
      </div>

      <div *ngIf="isContestFinishedForStudent(contest) && contest.paymentStatus == paymentStatuses.successful"
           fxLayout="column"
           fxFlex="10%"
           class="list-item-column">
        <span class="top text-disabled-color mat-small">
          <ng-container i18n="General|Results action label@@general-results-action-label">Results</ng-container>:</span>

        <a mat-mini-fab color="accent" class="center-vertical results-btn"
           [routerLink]="getExamCardUrl(contest)"
           matTooltip="Results"
           i18n-matTooltip="General|Results action label@@general-results-action-label">
          <mat-icon>insert_chart_outlined</mat-icon>
        </a>
      </div>

      <div class="fill-space"></div>

      <div fxLayout="column" fxFlex="30px" class="list-actions">
        <mat-icon *ngIf="editAllowed || deleteAllowed || (showTeacherDetails && isContestFinished(contest)) || isContestCancelEnrolAllowed(contest)"
                  class="actions-icon"
                  [matMenuTriggerFor]="menu"
                  (click)="$event.stopPropagation()">more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button *ngIf="editAllowed && !isContestStarted(contest)" mat-menu-item
                  (click)="editContest(contest)">
            <mat-icon>edit</mat-icon>
            <span
              i18n="General|Edit action label@@general-edit-action-label">Edit</span>
          </button>
          <button *ngIf="(isContestStarted(contest) || isContestFinished(contest)) && !showTeacherDetails" mat-menu-item
                  (click)="showContestDetails(contest)">
            <mat-icon>info</mat-icon>
            <span i18n="General|Details action label@@general-details-action-label">Details</span>
          </button>
          <button *ngIf="editAllowed" mat-menu-item
                  (click)="editContestTasks(contest)">
            <mat-icon>settings_suggest</mat-icon>
            <span
              i18n="General|Tasks action label@@general-tasks-action-label">Tasks</span>
          </button>
          <button *ngIf="editAllowed && !isContestStarted(contest)" mat-menu-item
                  (click)="cloneContestTasks(contest)">
            <mat-icon>move_up</mat-icon>
            <span
              i18n="Contests Tasks|Clone tasks action label@@contests-clone-tasks-action-label">Clone Tasks</span>
          </button>
          <button *ngIf="editAllowed && !isContestFinished(contest)" mat-menu-item
                  (click)="getExamDirectUrl(contest)">
            <mat-icon>link</mat-icon>
            <span i18n="General|Direct URL action label@@general-direct-url-action-label">Direct URL</span>
          </button>
          <button *ngIf="editAllowed" mat-menu-item
                  (click)="previewContestTasks(contest)">
            <mat-icon>visibility</mat-icon>
            <span i18n="General|Preview action label@@general-preview-action-label">Preview</span>
          </button>
          <button *ngIf="editAllowed && !isCertificateEditAllowed(contest)" mat-menu-item
                  (click)="editContestCertificate(contest)">
            <mat-icon>verified</mat-icon>
            <span
              i18n="General|Certificate action label@@general-certificate-action-label">Certificate</span>
          </button>
          <button *ngIf="deleteAllowed" mat-menu-item (click)="deleteContest(contest)">
            <mat-icon>delete</mat-icon>
            <span
              i18n="General|Delete action label@@general-delete-action-label">Delete</span>
          </button>
          <button *ngIf="isContestCancelEnrolAllowed(contest)" mat-menu-item (click)="cancelContestEnrol(contest)">
            <mat-icon>delete</mat-icon>
            <span
              i18n="General|Cancel action label@@general-cancel-action-label">Cancel</span>
          </button>
          <button *ngIf="isContestFinished(contest) && showTeacherDetails && contest" mat-menu-item (click)="showTeacherContestInfo(contest)">
            <mat-icon>auto_stories</mat-icon>
            <span
              i18n="General|Results action label@@general-results-action-label">Results</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-list-item>
</mat-list>
